var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50233 7.50998C6.33772 7.51093 6.17453 7.47938 6.02214 7.41713C5.86974 7.35489 5.73113 7.26317 5.61426 7.14724L0.611017 2.144C0.494393 2.02738 0.401883 1.88893 0.338766 1.73655C0.27565 1.58417 0.243164 1.42086 0.243164 1.25593C0.243164 1.091 0.27565 0.92768 0.338766 0.775304C0.401883 0.622928 0.494393 0.484476 0.611017 0.367852C0.727641 0.251229 0.866093 0.158717 1.01847 0.095601C1.17085 0.0324847 1.33416 -2.45766e-09 1.49909 0C1.66402 2.45766e-09 1.82734 0.0324847 1.97972 0.095601C2.13209 0.158717 2.27054 0.251229 2.38717 0.367852L6.50233 4.50804L10.63 0.530458C10.7451 0.402513 10.8853 0.299685 11.0419 0.228406C11.1985 0.157128 11.3682 0.118931 11.5402 0.116205C11.7123 0.11348 11.883 0.146282 12.0418 0.212564C12.2006 0.278846 12.344 0.37718 12.4631 0.501416C12.5822 0.625652 12.6743 0.773118 12.7338 0.93459C12.7932 1.09606 12.8188 1.26807 12.8087 1.43985C12.7987 1.61163 12.7533 1.77949 12.6754 1.93294C12.5975 2.08638 12.4888 2.22211 12.3561 2.33162L7.35288 7.15975C7.12414 7.38029 6.82004 7.50551 6.50233 7.50998Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.b2f0ffc653acdf70b3f7cb8d9e9fc193.svg";
export { ForwardRef as ReactComponent };